import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

import ChevronLeft from 'react-feather/dist/icons/chevron-left.js';
import ChevronRight from 'react-feather/dist/icons/chevron-right.js';

export default class Pagination extends Component {
  static propTypes = {
    current: PropTypes.number.isRequired,
    generateLink: PropTypes.func.isRequired,
    pagesCount: PropTypes.number.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {current, generateLink, pagesCount} = this.props;
    if (pagesCount <= 1) {
      return null;
    }

    const hasPrevious = (current > 0);
    const hasNext = (current < pagesCount - 1);

    return (
      <nav aria-label="Pagination" className={this.props.className}>
        <ul className="pagination">
          <li className={`page-item ${!hasPrevious ? 'disabled' : ''}`}>
            <Link to={generateLink(0)} className="page-link d-flex align-items-center h-100">
              <ChevronLeft size={20}/><ChevronLeft size={20}/>
            </Link>
          </li>
          <li className={`page-item ${!hasPrevious ? 'disabled' : ''}`}>
            <Link disabled={!hasPrevious} to={generateLink(current - 1)} className="page-link d-flex align-items-center h-100">
              <ChevronLeft size={20}/>
            </Link>
          </li>
          <li className="page-item">
            <Link disabled={true} to={generateLink(current)} className="page-link">{current + 1}</Link>
          </li>
          <li className={`page-item ${!hasNext ? 'disabled' : ''}`}>
            <Link to={generateLink(current + 1)} disabled={!hasNext} className="page-link d-flex align-items-center h-100">
              <ChevronRight size={20}/>
            </Link>
          </li>
          <li className={`page-item ${!hasNext ? 'disabled' : ''}`}>
            <Link to={generateLink(pagesCount - 1)} disabled={!hasNext} className="page-link d-flex align-items-center h-100">
              <ChevronRight size={20}/><ChevronRight size={20}/>
            </Link>
          </li>
        </ul>
      </nav>
    )
  }
}
